import type { PopoverProps } from "antd";

type AdjustOverflow = Exclude<PopoverProps["autoAdjustOverflow"], boolean | undefined>;

/**
 * For antd Dropdown / Popover / Tooltip with a corner placement (bottomRight, topLeft, …): antd only
 * flips those to the other side when they'd leave the screen. shiftX lets it also slide them back
 * along the edge, which is what a narrow phone screen needs. antd passes shiftX through to its
 * positioning at runtime; its public type only lists the flip flags, hence the cast.
 *
 * Usage: <Dropdown autoAdjustOverflow={POPUP_KEEP_IN_VIEWPORT} …>
 */
export const POPUP_KEEP_IN_VIEWPORT = { adjustX: 1, adjustY: 1, shiftX: true } as AdjustOverflow;
